module.exports = __webpack_public_path__ + "assets/img/Sonance_010.f2996e97.jpg";